import { render } from "./Loader.vue?vue&type=template&id=4420deb8&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=4420deb8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4420deb8"

export default script